const equipmentProfile = {
  area: "Area",
  backbtn: "Go Back",
  chooseADateRange: "Choose A Date Range",
  comment: "Comment",
  createdBy: "Created By",
  customer: "Customer",
  dateCreated: "Date Created",
  deleteEquipment: "Delete Equipment",
  equipment: "Equipment",
  equipmentStatus: "Equipment Status",
  equipmentTag: "Equipment Tag",
  equipmentType: "Equipment Type",
  goBack: "Go Back",
  hazardous: "Hazardous Area Classification",
  manufacturer: "Manufacturer",
  model: "Model",
  nocomment: "None",
  product: "Product",
  pumpHousing: "Pump Housing",
  responsible: "Select responsible for the equipment",
  sealTypes: "Mechanical Seal Types",
  snackText: "Your file has been downloaded into Downloads Folder",
  unit: "Unit",
  updatebtn: "UPDATE EQUIPMENT"
};
export default equipmentProfile;
